<template>
  <div>
    <el-dialog :title="dtiTit"
             :visible.sync="dialogVisible"
             custom-class="importDialogq"
             @close="hide"
             :close-on-click-modal="false"
             :close-on-press-escape="false">
      <el-form :model="dtiform"
              :rules="rules"
              ref="refDialog"
              v-loading="loading"
              label-width="100px">
        <el-row :gutter="20">
          <el-col :span="6" v-for="(item, index) in serchList" :key="index">
            <el-form-item label-width
                          v-if="item.type == 'text'"
                          :prop="item.file"
                          :label="item.name">
              <el-input v-model="dtiform[item.file]" style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label-width
                          v-if="item.type == 'date'"
                          :prop="item.file"
                          :label="item.name">
              <el-date-picker v-model="dtiform[item.file]"
                              type="datetimerange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              style="width: 100%;"
                              value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            <el-form-item label-width
                          v-if="item.type == 'number'"
                          :prop="item.file"
                          :label="item.name">
              <number-range v-model="dtiform[item.file]" style="width: 100%;"/>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item>
              <el-button type="primary" @click="searBtn">搜索</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-card class="button-box">
          <el-button size="medium" type="primary" @click="handleExport">导出</el-button>
        </el-card>
        <!-- el-table -->
        <el-table v-loading="loading"
                  height="calc(100vh - 100px)"
                  border
                  :data="tableData"
                  row-key="id"
                  ref="dtiTbl"
                  style="width: 100%">
            <el-table-column :prop="item.label" v-for="(item, index) in titleData" :key="index" :label="item.name" align="center"></el-table-column>
        </el-table>
        <el-card v-if="total>0">
          <el-row class="pagation-row">
            <el-pagination background
                          @size-change="handleSizeChange"
                          @current-change="handleCurrentChange"
                          :current-page.sync="queryPrdlists.pagenum"
                          :page-size="queryPrdlists.pagesize"
                          :page-sizes="[10, 20, 50, 100]"
                          layout="total, sizes, prev, pager, next, jumper"
                          :total="total"></el-pagination>
          </el-row>
        </el-card>
      </el-form>
    </el-dialog>
    <export-dialog ref="refExportDialog"
                    @submit="exportSubmit" />
  </div>  
</template>

<script>
import SearchMixin from './search-mixin'
import ExportDialog from './exportDialog'
import * as Desc from './desc'
export default {
  // mixins: [getplatlists, getptnlists, getshoplists],
  mixins: [SearchMixin],
  props: { queryInfo: Object },
  components: { ExportDialog },
  data() {
    return {
      dialogVisible: false,
      query: this.queryInfo,
      form: {
        profession: '',
        business: '',
        store: '',
      },
      Desc,
      queryPrdlists: {
        pagenum: 1,
        pagesize: 20
      },
      dtiform: {},
      dtiprm: {},
      tableData: [],
      serchList: [],
      titleData: [],
      total: 0,
      rules: {},
      sid: '',
      dtiTit: '',
      loading: false,
    }
  },
  created() {
  },
  methods: {
    show(row) {
      this.sid = row.id
      this.dtiTit = row.name
      this.getsurTitle()
      this.dialogVisible = true
    },
    hide() {
      this.dialogVisible = false
      this.form = {
        profession: '',
        business: '',
        store: '',
      }
      this.dtiform = {}
      this.$refs.refDialog.resetFields()
    },
    // 导出
    handleExport () {
      this.$refs.refExportDialog.show(this.dtiprm)
    },
    searBtn() {
      this.queryPrdlists.pagenum = 1
      this.getsurDetail()
    },
    // 详情 表头、搜索项
    async getsurTitle() {
      this.tableData = []
      this.serchList = []
      this.titleData = []
      this.loading = true
      let query = {
        url: 'surDetail_1',
        title: '问卷详情',
        method: 'post'
      }
      let parm = {
        sid: this.sid
      }
      let { data, err } = await this.axiosApi(
        query,
        parm
      )
      this.serchList = data.data.data.serch
      this.titleData = data.data.data.title
      this.getsurDetail()
      this.loading = false
      this.$nextTick(() => {
        this.$refs.dtiTbl.doLayout()
      })
    },
    async getsurDetail() {
      this.loading = true
      let query = {
        url: 'surDetail_2',
        title: '问卷详情',
        method: 'post'
      }
      let parm = {
        query: {
          sid: this.sid,
          business: this.query.business,
          profession: this.query.profession,
          store: this.query.store
        },
        pagenum: this.queryPrdlists.pagenum,
        pagesize: this.queryPrdlists.pagesize,
        reportname: this.queryPrdlists.reportname
      }
      Object.assign(parm.query, this.dtiform)
      this.dtiprm = parm
      let { data, err } = await this.axiosApi(
        query,
        this.dtiprm
      )
      this.tableData = data.data.data.data
      this.total = data.data.data.total
      this.loading = false
    },
    handleSizeChange(val) {
      this.queryPrdlists.pagesize = val
      this.searBtn()
    },
    handleCurrentChange(val) {
      this.queryPrdlists.pagenum = val
      this.getsurDetail()
    },
  },
  watch: {
  },
  filters: {
  },
}
</script>
<style lang="scss" scoped>
.el-dialog__wrapper >>> {
  .importDialogq {
    width: 80%;
  }
  .el-input {
    max-width: 200px;
  }
  label {
    font-size: 15px;
    // font-weight: 600;
  }
  .row {
    margin-top: 15px;
    .el-col {
      // height: 32px;
      line-height: 32px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/base/memberquesrgath/dialog.vue